module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-block",
    class: _vm.data.class
  }, [_vm._v("\n  " + _vm._s(_vm.time) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6765dfc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockTime.vue
// module id = 698
// module chunks = 0